import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';

export const Skeleton = () => <Box xcss={styles} />;

const styles = xcss({
	background: 'color.skeleton',
});
